module.exports = __webpack_public_path__ + "media/images/icons/filled/clock-circle-4a0dc71a07f5439639feef60f434940a.svg";